import { ActivitiesContentType, LESSON_ACTIVITIES } from 'global/constants';
import { PStyled } from 'approot/shared/styles/typography.style';
import * as Styled from './activity-draft-banner.style';

type Props = {
  isDrawerActive: boolean;
  isDrawerDetailsActive: boolean;
  contentType: ActivitiesContentType;
};

const ActivityDraftBanner = ({
  isDrawerActive,
  isDrawerDetailsActive,
  contentType,
}: Props) => {
  return (
    <Styled.DraftBanner
      $isDrawerActive={isDrawerActive}
      $isDrawerDetailsActive={isDrawerDetailsActive}
    >
      <PStyled marginBottom={0}>
        <strong>
          This is a draft{' '}
          {contentType === LESSON_ACTIVITIES ? 'lesson' : 'assessment'}.
        </strong>{' '}
        Responses added in present mode will not be saved.
      </PStyled>
    </Styled.DraftBanner>
  );
};

export default ActivityDraftBanner;
